const initialState = {
    authenticated: false,
    userId: undefined,
    token: undefined,
    userInfo: {
        /*
        username: 'andy@email.com',
        phoneNumber: '112312332',
        subscription: '1 Year',
        expiryDate: 1548931122,
        */
    },
};

export default initialState;



// WEBPACK FOOTER //
// ./src/common/initial-state/auth.js